import axios from "./axios";
let BASE = null;
process.env.NODE_ENV === 'development' ? BASE = "/api" : BASE = '';
// 登录
export const getLogin = params => axios(`${BASE}/login/to`, params, "PSOT");
  
